var e = { admin: {
	queue: {
		columns: {
			source: "Source",
			document: "Document",
			signals: "Signals"
		},
		source: {
			manual: "Manual",
			didit: "Didit",
			unknown: "—",
			manualHint: "Submitted for review",
			diditReview: "Needs a human"
		},
		empty: {
			title: "Nothing waiting",
			body: "No identity or business verification needs a decision right now."
		},
		filtered: {
			title: "Nothing matched",
			body: "No verification matches these filters. Clear one to widen the queue."
		}
	},
	user: {
		title: "Identity verification (KYC)",
		noRecord: {
			title: "Nothing submitted",
			body: "This person has not started identity verification."
		},
		readError: {
			title: "Couldn't load this verification",
			body: "Nothing here reflects the record. Their verification is unchanged — this is a problem reading it.",
			action: "Try again"
		},
		fields: {
			submitted: "Submitted",
			reviewed: "Reviewed",
			notSubmitted: "Not submitted",
			rejectionReason: "Rejection reason"
		},
		details: {
			title: "Details",
			fullLegalName: "Full legal name",
			dateOfBirth: "Date of birth"
		},
		documents: { title: "Documents ({{total}})" },
		actions: {
			approve: "Approve",
			reject: "Reject"
		}
	},
	provider: {
		title: "Provider evidence",
		subtitle: "What the identity provider extracted and scored. Never the source documents.",
		manualOnly: "This record was submitted by hand, so there is no provider evidence to show.",
		fields: {
			provider: "Provider",
			providerStatus: "Provider status",
			nationality: "Nationality",
			issuingState: "Issuing state",
			documentType: "Document type",
			liveness: "Liveness",
			faceMatch: "Face match",
			warningCodes: "Warning codes",
			completedAt: "Decided",
			retentionUntil: "Retention until",
			session: "Provider session"
		},
		notReported: "Not reported",
		noWarnings: "None"
	},
	documents: { empty: {
		title: "No documents here",
		providerBody: "The provider keeps the captured images. What it extracted is in the evidence panel above.",
		manualBody: "This submission has no uploaded documents yet."
	} },
	documentType: {
		passport: "Passport",
		national_id: "National ID",
		driving_license: "Driving licence",
		id_card: "ID card",
		residence_permit: "Residence permit"
	},
	risk: {
		countryMismatch: "Country mismatch",
		countryMismatchHint: "The connecting IP's country matches neither the issuing state nor the nationality on the document.",
		vpnDetected: "VPN or Tor",
		vpnDetectedHint: "The provider reported the session's IP as a VPN or Tor exit.",
		clear: "No flags",
		notAssessed: "Not assessed",
		notAssessedHint: "No network analysis ran against this record, so there is nothing to flag either way.",
		warnings_one: "{{count}} warning",
		warnings_other: "{{count}} warnings"
	},
	resync: {
		action: "Resync from Didit",
		running: "Asking the provider…",
		unavailable: {
			noSession: "This record has no provider session to resync.",
			notConfigured: "The identity provider is not configured in this environment."
		},
		outcome: {
			applied: "A fresh verdict was applied.",
			already_verified: "Already verified — a verdict nothing may overwrite.",
			stale: "The provider's answer is older than what this record already holds.",
			session_not_found: "The provider has no record of this session.",
			unknown_status: "The provider answered with a status this platform does not model. The record was left alone."
		},
		failed: "Could not reach the identity provider.",
		overrideTitle: "Replace an admin's decision?",
		overrideBody: "A platform admin reviewed this record after the provider last decided. Resyncing replaces that decision with the provider's, and the applicant is told the new outcome. This is recorded against your account.",
		overrideConfirm: "Replace it"
	},
	inbox: {
		title: "Didit Inbox",
		subtitle: "Every verdict Didit has signed and sent us, and what became of it. Envelopes only — a parked body holds the document fields the identity record is encrypted to protect.",
		stats: {
			quarantined: "Quarantined",
			quarantinedHint: "Parked for a human. A retry can never resolve these.",
			retryable: "Retrying",
			retryableHint: "Failed on something transient.",
			pending: "Awaiting the drain",
			pendingHint: "Captured, waiting for the drain. Seconds, normally.",
			processed: "Processed",
			processedHint: "Applied to a verification record. Most of this table.",
			oldest: "Oldest unresolved",
			oldestNone: "Nothing waiting",
			dlqDepth: "Dead-lettered",
			dlqDepthHint: "Messages parked on the broker queue.",
			dlqUnavailable: "Unknown — the service could not be reached."
		},
		columns: {
			event: "Event",
			type: "Type",
			session: "Session",
			status: "Status",
			retries: "Retries",
			reason: "Reason",
			received: "Received"
		},
		filters: {
			allStatuses: "All statuses",
			sessionPlaceholder: "Filter by session id…"
		},
		status: {
			pending: "Pending",
			processed: "Processed",
			failed_retryable: "Retrying",
			quarantined: "Quarantined"
		},
		noReason: "—",
		redrive: {
			action: "Redrive dead-lettered",
			running: "Redriving…",
			confirmTitle: "Redrive dead-lettered deliveries?",
			confirmBody: "Every message parked on main.didit_webhook_inbox is republished for the drain to try again. A delivery that already applied is a no-op; a quarantined record is not reached by this at all — use Resync on the record instead.",
			confirm: "Redrive",
			done_one: "Redrove {{count}} message.",
			done_other: "Redrove {{count}} messages.",
			failed: "Redrive failed.",
			nothing: "Nothing is parked on the broker queue."
		},
		payloadNotice: "The stored body is never shown here. What a quarantined delivery could not tell us is in its reason; what it contains is a person's identity document.",
		empty: {
			title: "Nothing has arrived yet",
			body: "Didit has not signed a delivery to this environment. That is the expected state until a verification session completes."
		},
		filtered: {
			title: "Nothing matched",
			body: "No captured delivery matches these filters."
		}
	},
	providerDocuments: {
		title: "Documents at the provider",
		subtitle: "MAAT does not store identity documents. The images this verification was based on are held by the verification provider — open the session there to review them.",
		action: "Open in Didit",
		sessionId: "Session {{id}}",
		unavailable: {
			noSession: "This record has no provider session — it was submitted manually, or predates automated verification. Any documents are in the Documents panel below.",
			purged: "The provider copy of this session was destroyed, so there is nothing left to open. This is permanent."
		}
	}
} };
//#endregion
export { e as default };
